var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.342,
    height: 169.886,
    viewBox: "0 0 171.342 169.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2373",
    "data-name": "Group 2373",
    transform: "translate(-334 -1093.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2371",
    "data-name": "Group 2371",
    transform: "translate(334 1093.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 77.459,
    cy: 77.459,
    r: 77.459,
    transform: "translate(2.804 14.969)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2364",
    "data-name": "Group 2364",
    transform: "translate(0 34.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M5.608,0H107.6a5.608,5.608,0,0,1,5.608,5.608V45.564a5.608,5.608,0,0,1-5.608,5.608H98.673V63.2L81.939,51.172H5.608A5.608,5.608,0,0,1,0,45.564V5.608A5.608,5.608,0,0,1,5.608,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 38.554,
    height: 5.257,
    rx: 2.629,
    transform: "translate(11.216 11.216)",
    fill: "#195cff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 73.603,
    height: 5.257,
    rx: 2.629,
    transform: "translate(11.216 24.885)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 28.039,
    height: 5.257,
    rx: 2.629,
    transform: "translate(11.216 35.4)",
    fill: "#dce5f4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 28.74,
    height: 3.855,
    rx: 1.928,
    transform: "translate(138.837 29.375) rotate(-45)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 16.824,
    height: 3.855,
    rx: 1.928,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 154.094, 42.777)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 17.875,
    height: 3.855,
    rx: 1.928,
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 122.253, 17.266)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365",
    transform: "translate(49.509 99.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M107.6,0H5.608A5.608,5.608,0,0,0,0,5.608V45.564a5.608,5.608,0,0,0,5.608,5.608h8.928V63.2L31.27,51.172H107.6a5.608,5.608,0,0,0,5.608-5.608V5.608A5.608,5.608,0,0,0,107.6,0Z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 32.946,
    height: 5.257,
    rx: 2.629,
    transform: "translate(11.216 11.216)",
    fill: "#195cff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 73.603,
    height: 5.257,
    rx: 2.629,
    transform: "translate(11.216 24.885)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 28.039,
    height: 5.257,
    rx: 2.629,
    transform: "translate(11.216 35.4)",
    fill: "#dce5f4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/no-messages.cce0087971b865bd41fffef3c7992d0f.svg";
export { ForwardRef as ReactComponent };